import { TFunction } from 'i18next'
import { BooleanSchema } from 'yup'

import { checkboxSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const requiredCheckboxSchema = (
  t: TFunction<'translation', undefined>,
): BooleanSchema<boolean | undefined> =>
  checkboxSchema(t).test(
    'must-be-accepted',
    t(formTranslation.errors.privacyPolicy),
    value => value === true,
  )
